var map = {
	"./ARE_36.png": 5818,
	"./ARE_48.png": 1901,
	"./ARE_64.png": 815,
	"./AUS_36.png": 2919,
	"./AUS_48.png": 376,
	"./AUS_64.png": 8318,
	"./BGD_36.png": 4581,
	"./BGD_48.png": 134,
	"./BGD_64.png": 8624,
	"./BRU_36.png": 1263,
	"./BRU_48.png": 1744,
	"./BRU_64.png": 646,
	"./CAN_36.png": 1282,
	"./CAN_48.png": 8773,
	"./CAN_64.png": 8343,
	"./CHE_36.png": 9094,
	"./CHE_48.png": 5097,
	"./CHE_64.png": 9731,
	"./CHN_36.png": 1695,
	"./CHN_48.png": 1008,
	"./CHN_64.png": 8473,
	"./CNH_64.png": 2026,
	"./DNK_36.png": 1203,
	"./DNK_48.png": 1636,
	"./DNK_64.png": 3042,
	"./EEE_36.png": 7653,
	"./EEE_48.png": 5670,
	"./EEE_64.png": 9728,
	"./GBR_36.png": 3769,
	"./GBR_48.png": 1850,
	"./GBR_64.png": 1420,
	"./HKG_36.png": 1774,
	"./HKG_48.png": 577,
	"./HKG_64.png": 8891,
	"./IDN_36.png": 6849,
	"./IDN_48.png": 194,
	"./IDN_64.png": 5556,
	"./IDR_64.png": 1032,
	"./JPN_36.png": 1064,
	"./JPN_48.png": 9307,
	"./JPN_64.png": 1577,
	"./KHR_64.png": 2986,
	"./MYS_36.png": 6111,
	"./MYS_48.png": 3808,
	"./MYS_64.png": 1862,
	"./NOR_36.png": 2783,
	"./NOR_48.png": 9072,
	"./NOR_64.png": 3094,
	"./NZL_36.png": 8244,
	"./NZL_48.png": 5463,
	"./NZL_64.png": 9773,
	"./PHL_36.png": 3592,
	"./PHL_48.png": 7275,
	"./PHL_64.png": 2073,
	"./QAT_36.png": 9918,
	"./QAT_48.png": 9169,
	"./QAT_64.png": 4715,
	"./SAU_36.png": 6443,
	"./SAU_48.png": 5052,
	"./SAU_64.png": 1914,
	"./SGP_36.png": 1786,
	"./SGP_48.png": 7869,
	"./SGP_64.png": 3135,
	"./SWE_36.png": 9965,
	"./SWE_48.png": 3985,
	"./SWE_64.png": 2696,
	"./THA_36.png": 9423,
	"./THA_48.png": 7120,
	"./THA_64.png": 8822,
	"./THB_64.png": 363,
	"./USA_36.png": 5207,
	"./USA_48.png": 9016,
	"./USA_64.png": 7230,
	"./VND_64.png": 4881
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4737;